import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, catchError, map, throwError} from 'rxjs';
import {Logger} from 'src/app/core/interfaces/Logger';
import {HttpBodyResponse} from 'src/app/core/api-dto/interface/api-http-response.interface';
import {buildHttpParams} from 'src/app/shared/utils/http.utils';

@Injectable()
export abstract class BaseHttpService {
  protected abstract baseUrl: string;

  protected readonly http = inject(HttpClient);
  protected readonly logger = inject(Logger);

  protected get<T>(endpoint = '', query?: Record<string, unknown>): Observable<T> {
    return this.handle(
      this.http.get<HttpBodyResponse<T>>(this.url(endpoint), {
        params: buildHttpParams(query),
      })
    );
  }

  protected post<T>(endpoint: string, payload: unknown, options?: { headers?: Record<string, string>, params?: Record<string, unknown> }): Observable<T> {
    return this.handle(
      this.http.post<HttpBodyResponse<T>>(this.url(endpoint), payload, {
        headers: options?.headers,
        params: buildHttpParams(options?.params),
      })
    );
  }

  protected put<T>(endpoint: string, payload: unknown): Observable<T> {
    return this.handle(
      this.http.put<HttpBodyResponse<T>>(this.url(endpoint), payload)
    );
  }

  private url(endpoint: string): string {
    const base = this.baseUrl.replace(/\/+$/g, '');
    const path = endpoint.replace(/^\/+/g, '');

    return path ? `${base}/${path}` : base;
  }

  private handle<T>(req$: Observable<HttpBodyResponse<T>>): Observable<T> {
    return req$.pipe(
      map(response => response?.data ?? (response as unknown as T)),
      catchError((err) => {
        this.logger.error(err, '[Http] Request failed');

        return throwError(() => err);
      })
    );
  }
}
